import { FormControl, Grid } from "@mui/material";
import { HStack } from "@zfp-akademie-a-s/zfp-design";
import { FormSelect } from "@zfp-akademie-a-s/zfp-design/form";
import { FormMaskedField } from "@zfp-akademie-a-s/zfp-design/form/masked-field";
import { ReactComponent as IconAUT } from "Components/_Shared/Icons/Countries/AUT.svg";
import { ReactComponent as IconCZE } from "Components/_Shared/Icons/Countries/CZE.svg";
import { ReactComponent as IconDEU } from "Components/_Shared/Icons/Countries/DEU.svg";
import { ReactComponent as IconPOL } from "Components/_Shared/Icons/Countries/POL.svg";
import { ReactComponent as IconsSVK } from "Components/_Shared/Icons/Countries/SVK.svg";
import { useListPhonePrefixes } from "Infrastructure/ApiZfp/AnalyzerApi";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues> = {
  readonly prefixInputName: FieldPath<FormType>;
  readonly numberInputName: FieldPath<FormType>;
  readonly control: Control<FormType, object>;
  readonly label?: string;
  readonly required?: boolean;
  readonly disabled?: boolean;
};

const getIcon = (value: string) => {
  switch (value) {
    case "+420":
      return <IconCZE />;
    case "+421":
      return <IconsSVK />;
    case "+48":
      return <IconPOL />;
    case "+49":
      return <IconDEU />;
    case "+43":
      return <IconAUT />;
  }
};

const prefixLabel = (prefix: string, text: string) => (
  <HStack component="span" alignItems="center" gap={Spacing.M}>
    {getIcon(prefix)}
    {text}
  </HStack>
);

export const PhoneInput = <T extends FieldValues>({ label, required, prefixInputName, numberInputName, control, disabled }: Props<T>) => {
  const { data } = useListPhonePrefixes();

  const prefixes = data?.map((item) => ({ value: item.prefix, label: prefixLabel(item.prefix, `${item.code} ${item.prefix}`) })) || [
    { value: "+420", label: prefixLabel("+420", "") },
  ];

  return (
    <FormControl fullWidth>
      <Grid container spacing={Spacing.L} alignItems="flex-end">
        <Grid size={6.2}>
          <FormSelect
            control={control}
            name={prefixInputName}
            label={label}
            required={required}
            disabled={disabled}
            options={prefixes}
            slotProps={{ select: { renderValue: (prefix) => prefixLabel(String(prefix), String(prefix)) } }}
            fullWidth
          />
        </Grid>
        <Grid size={5.8}>
          <FormMaskedField control={control} name={numberInputName} disabled={disabled} mask="000 000 000" fullWidth />
        </Grid>
      </Grid>
    </FormControl>
  );
};
